import Divider from '@mui/material/Divider';
import classnames from 'classnames';
import startCase from 'lodash/startCase';
import React from 'react';
import PropTypes from 'prop-types';
import { useHoverIntent } from 'react-use-hoverintent';
import { RefinementListFilter } from 'searchkit';
import FilterContainer from './FilterContainer';

import styles from './RefinementListFilterDivider.css';

const withProps = (WrappedComponent, props) => {
  function WithMergedProps({ children, ...rest }) {
    return (
      <WrappedComponent {...rest} {...props}>
        {children}
      </WrappedComponent>
    );
  }
  WithMergedProps.displayName = 'WithMergedProps';
  return WithMergedProps;
};

function RefinementListFilterDivider({
  onClose,
  isDragging,
  disabled,
  canManage = true,
  ...props
}) {
  const Component = props.component || RefinementListFilter;
  const [over, intentRef] = useHoverIntent({
    sensitivity: 1,
    interval: 400,
  });

  const outline = canManage && (over || isDragging);

  const containerComponent = withProps(FilterContainer, {
    draggable: canManage,
    outline,
    intentRef,
    onClose: canManage ? onClose : undefined,
  });
  return (
    <div className={classnames(styles.container, { [styles.outline]: outline })}>
      {!outline && !disabled && <Divider />}
      <Component
        {...props}
        title={startCase(props.title)}
        containerComponent={containerComponent}
      />
    </div>
  );
}

export default RefinementListFilterDivider;

RefinementListFilterDivider.propTypes = {
  canManage: PropTypes.bool,
};
